import request from "@/utils/request";

export function selectPageList(data) {
  return request({
    url: "/test/reportEvaluation/selectPageList",
    method: "post",
    data: data,
  });
}

export function check(data) {
  return request({
    url: "/test/reportEvaluation/check",
    method: "post",
    data: data,
  });
}
export function generateReport(data) {
  return request({
    url: "/test/reportEvaluation/generateReport",
    method: "post",
    data: data,
  });
}
export function uploadFile(data) {
  return request({
    url: "/test/reportEvaluation/uploadFile",
    method: "post",
    data: data,
  });
}
export function detail(data) {
  return request({
    url: "/test/reportEvaluation/detail",
    method: "post",
    data: data,
  });
}
export function insertOne(data) {
  return request({
    url: "/test/reportEvaluation/insertOne",
    method: "post",
    data: data,
  });
}
export function getQualificationInfoDetailByCarId(carId) {
  return request({
    url: `/car/qualificationInfo/getQualificationInfoDetailByCarId?carId=${carId}`,
    method: "get",
  });
}
